import { Flex } from 'antd'
import React, { useRef } from 'react'

import { ReportsPageProps } from '@/components/feature/analytics/hooks/use-report-search'

import s from '../../fans-reports.module.css'

import FansReportsForCreatorFans from './fans-reports-for-creator-fans'
import FansReportsTopFans from './fans-reports-top-fans'

export interface FansReportsForCreatorProps extends ReportsPageProps {
  creatorId: number
}

export default function FansReportsForCreator({
  creatorId,
  searchValues,
}: FansReportsForCreatorProps) {
  const containerRef = useRef<HTMLDivElement>(null!)

  return (
    <Flex ref={containerRef} vertical className={s.reportsForCreator} gap={16}>
      <FansReportsForCreatorFans creatorId={creatorId} searchValues={searchValues} />
      <FansReportsTopFans
        containerRef={containerRef!}
        creatorId={creatorId}
        searchValues={searchValues}
      />
    </Flex>
  )
}
